import React, { useRef, useImperativeHandle, forwardRef } from "react";

/**
 * PdfViewer — renders a PDF in an iframe.
 *
 * Props:
 *   src        : PDF URL (data URL or blob URL)
 *   name       : title for the iframe
 *   cropActive : boolean — when true, disables pointer events so crop drag works
 *
 * Exposes ref.current.getMediaEl() for crop access.
 */

const PdfViewer = forwardRef(function PdfViewer({ src, name, cropActive }, ref) {
  const iframeRef = useRef(null);

  useImperativeHandle(ref, () => ({
    getMediaEl: () => iframeRef.current,
  }), []);

  return (
    <iframe
      key={src}
      ref={iframeRef}
      src={src}
      title={name}
      style={{
        ...styles.pdf,
        pointerEvents: cropActive ? "none" : "auto",
      }}
    />
  );
});

export default PdfViewer;

const styles = {
  pdf: {
    width: "100%",
    height: "100%",
    border: "none",
    display: "block",
  },
};